import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import EmptyState from '../../../components/EmptyState';

/**
 * Empty state shown in the service scraper panel when the scraping did not
 * find any service.
 */
const NoScrapedServices = () => {
    const translate = useTranslate();

    return (
        <EmptyState
            iconName='SearchOff'
            title={translate('no_scraped_services')}
            description={translate('no_scraped_services_description')}
        />
    );
};

export default NoScrapedServices;
